export const scrollToAnchor = (event) => {
  const { target } = event;

  const href = target.getAttribute('href');

  if (!href || !href.includes('#')) {
    return;
  }

  event.preventDefault();

  const elementId = href.replace('#', '');
  const element = document.getElementById(elementId);

  element.scrollIntoView({
    behavior: 'smooth',
    block: 'start',
  });
};
